import { drawingTemplates } from '@/models/drawing/drawingTemplates.ts'
import { useTranslation } from 'react-i18next'
import { Template, TemplateElement } from '@/models/drawing/drawingTypes.ts'

export default function useDrawingTemplates() {
  const { t } = useTranslation()
  function prepareElement(element: TemplateElement) {
    if (element.type !== 'text') {
      return element
    }

    const translated = t(element.content)
    if (translated) {
      return {
        ...element,
        content: element.uppercase ? translated.toUpperCase() : translated,
      }
    }

    return element
  }
  function prepareTemplate(template: Template): Template {
    return {
      ...template,
      elements: template.elements.map(el => prepareElement(el))
    }
  }

  return drawingTemplates.map(template => prepareTemplate(template))
}
